import { render, staticRenderFns } from "./InfoMessageSmall.vue?vue&type=template&id=0da43f06&scoped=true"
import script from "./InfoMessageSmall.vue?vue&type=script&lang=ts"
export * from "./InfoMessageSmall.vue?vue&type=script&lang=ts"
import style0 from "./InfoMessageSmall.vue?vue&type=style&index=0&id=0da43f06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da43f06",
  null
  
)

export default component.exports